module MainService {

    export interface IMainService {
        setJWT: (token: string) => void;
        setRfid: (uuid: string, name: string) => void;
        cleanJWT: () => void;
        geti18nLang: () => string;
        getUserTimezone: () => string;
        geti18nDefaultLang: () => string;
        reloadLang: () => void;
        getRfid: () => string;
        getRfidName: () => string;
        cleanRfid: () => void;
        getDefaultPhase: () => string;
        getDefaultPhaseName: () => string;
        cleanPhase: () => void;
    }

    export class CMainService implements IMainService {

        constructor(
            protected $sessionStorage: any,
            protected $timeout: angular.ITimeoutService,
            protected $translate: angular.translate.ITranslateService,
            protected GlobalApplicationData: any,
            protected jwtHelper: any,
            protected $resource: ng.resource.IResourceService,
            protected $q: angular.IQService,
            protected ConfigService: any,
            protected $localStorage: any
        ) {
    
        }

        /** 
         * Salvo il token e il payload 
        */
        public setJWT = (token: string): void => {

            console.log("set the jwt token:", token);

            this.$sessionStorage.identityToken = token;
            this.GlobalApplicationData.identityToken = token;
            this.GlobalApplicationData.jwtPayload = token ? this.jwtHelper.decodeToken(token) : null;

            console.log(this.GlobalApplicationData.jwtPayload);

            this.reloadLang();
        }

        /**
         * Setto il rfid da associare
         */
        public setRfid = (uuid: string, name:string): void => {

            console.log("set the uuid rfid:", uuid);

            this.$localStorage.rfiduuid = uuid;
            this.$localStorage.rfidname = name;
            this.GlobalApplicationData.rfiduuid = uuid;
            
            this.reloadLang();
        }

        /**
         * Recupero il rfid associato
         */
        public getRfid = (): string => {            
            console.log("get the uuid rfid");             
            this.GlobalApplicationData.rfiduuid = this.$localStorage.rfiduuid;            
            return this.GlobalApplicationData.rfiduuid;
        }

        /**
         * Recupero il nome del rfid
         */
        public getRfidName = (): string => {            
            console.log("get the uuid rfid name");             
            return this.$localStorage.rfidname;
        }

        /**
         * Elimino l'associazione del rfid
         */
        public cleanRfid = (): void => {            
            console.log("clean rfid");             
            this.$localStorage.rfidname = null;
            this.$localStorage.rfiduuid = null;
        }

        /**
         * Setto la phase di default
         */
        public setPhase = (id: string, name:string): void => {
            
            console.log("set the id phase:", id);

            this.$localStorage.phaserfidid = id;
            this.$localStorage.phaserfidname = name;
            this.GlobalApplicationData.phaserfidid = id;
            
            this.reloadLang();
        }

        /**
         * Elimino l'associazione della fase
         */
        public cleanPhase = (): void => {            
            console.log("clean phase");             
            this.$localStorage.phaserfidname = null;
            this.$localStorage.phaserfidid = null;
        }

        /**
         * Recupero la fase al rfid associato
         */
        public getDefaultPhase = (): string => {            
            console.log("get the id rfid phase");             
            this.GlobalApplicationData.phaserfidid = this.$localStorage.phaserfidid;            
            return this.GlobalApplicationData.phaserfidid;
        }

        /**
         * Recupero il nome della fase al rfid associato
         */
        public getDefaultPhaseName = (): string => {            
            console.log("get the name rfid phase");             
            return this.$localStorage.phaserfidname;
        }

        /**
         *  Elimino il token 
        */
        public cleanJWT = (): void => {
            this.$sessionStorage.identityToken = null;
            this.GlobalApplicationData.identityToken = null;
            this.GlobalApplicationData.jwtPayload = null;

            // TODO annullo rinnovo del token
        }

        /**
         * Lingua attualmente in uso recuperata dal Token
         */
        public geti18nLang = (): string => {
            var lang = this.GlobalApplicationData.defaultLang ? this.GlobalApplicationData.defaultLang: "it";
            return lang;
        }

        /**
         * Timezone attualmente in uso recuperata dal Token
         */
        public getUserTimezone = (): string => {
            return "Europe/Rome";
        }

        /**
         * La lingua di default
         */
        public geti18nDefaultLang = (): string => {
            for (var i = 0; i < this.GlobalApplicationData.langs.length; i++) {
                if (this.GlobalApplicationData.langs[i].mandatory) {
                    return this.GlobalApplicationData.langs[i].lang.substring(0, 2);
                }
            }

            var lang = this.GlobalApplicationData.defaultLang ? this.GlobalApplicationData.defaultLang: "it";
            return lang;
        }

        public reloadLang = (): void => {
            let langKey = this.geti18nLang();

            if (!langKey) {
                langKey = this.geti18nDefaultLang();
            }

            console.log("set lang key:", langKey);

            this.$translate.use(langKey);
        };
    }

    // registro la factory
    angular.module("AdeMesApp").factory("MainService", ($sessionStorage: any, $timeout: angular.ITimeoutService, $translate: angular.translate.ITranslateService,GlobalApplicationData: any, jwtHelper: any, $resource: ng.resource.IResourceService, $q: angular.IQService, ConfigService: any, $localStorage: any) => new MainService.CMainService($sessionStorage, $timeout, $translate, GlobalApplicationData, jwtHelper, $resource, $q, ConfigService,$localStorage));
}
